// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"CloseButton_CloseButton__atUi8","hiddenDesktop":"CloseButton_hiddenDesktop__IRm9T","hiddenMobile":"CloseButton_hiddenMobile__hcgoU"};